import { createAction } from '@reduxjs/toolkit';

export const SEND_DTMF_ACTION_TYPE = 'saga/sendDtmf';
export const sendDtmfAction = createAction(SEND_DTMF_ACTION_TYPE);
